import ApiError from "../../api/common/apiError";
import { type ApiDriversListResponse } from "../../models/api/admin/driver";
import { type ApiCompanySummary } from "../../models/api/admin/company";
import FormMessageBox from "../FormMessageBox";
import PaginationNav from "../PaginationNav";
import Table, { type TableHeader } from "../ReusableComponents/Table";
import {
    initDriverChartAnalysisTableContents,
} from "./driverChartAnalysisTableInit";
import { useCompany } from "../../api/admin/company";

type DriverChartAnalysisTableProps = {
    driversList?: ApiDriversListResponse;
    fetchDriversError?: ApiError;
    isFetchingDrivers?: boolean;
    setPageNumber: (value: number) => void;
    pageSize: number;
    setPageSize: (value: number) => void;
    selectedCompany?: ApiCompanySummary;
    tableHeaders: TableHeader[];
    setTableHeaders: (value: TableHeader[]) => void;
};

const DriverChartAnalysisTable: React.FC<DriverChartAnalysisTableProps> = ({
    driversList,
    fetchDriversError,
    isFetchingDrivers,
    setPageNumber,
    pageSize,
    setPageSize,
    selectedCompany,
    tableHeaders,
    setTableHeaders,
}) => {
    if (!isFetchingDrivers && driversList && !driversList.items.length) {
        return <div>No drivers found</div>;
    }


    const initHiddenCols = new Array(0);
    tableHeaders.map((item) =>
        initHiddenCols.push({
            id: item.id,
            hidden: item.hide ?? false,
        })
    );

    /** If selectedCompany exists
     * fetch company so we can get correct risk profiles for table.
     *
     * Delays loading time of table.
     */
    const { companyData, isLoadingCompany } = useCompany(
        selectedCompany?.companyId
    );
    const isLoading = selectedCompany
        ? isFetchingDrivers || isLoadingCompany
        : isFetchingDrivers;

    const tableContents = initDriverChartAnalysisTableContents(
        driversList?.items ?? [],
        companyData?.companyRiskProfiles
    );

    return (
        <>
            {fetchDriversError && (
                <FormMessageBox
                    title={"error"}
                    message={
                        <span>
                            There was an error loading driver data.
                            <br />
                            Please try again in 10 minutes.
                        </span>
                    }
                    variant={"error"}
                />
            )}
            <Table
                tableHeaders={tableHeaders}
                setTableHeaders={setTableHeaders}
                tableContents={tableContents}
                hiddenCols={initHiddenCols}
                isLoading={isLoading}
            />
            {driversList && (
                <PaginationNav
                    setPageNumber={setPageNumber}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    totalCount={driversList.totalCount}
                    totalPages={driversList.totalPages}
                    currentPage={driversList.pageNumber}
                    hasPreviousPage={driversList.hasPreviousPage}
                    hasNextPage={driversList.hasNextPage}
                />
            )}
        </>
    );
};

export default DriverChartAnalysisTable;
